import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a82e0240eb2420014b82bf6_1787215315099_2eecb6cb/nerdlora/src/app/sign-up-login-screen/components/AuthScreen.tsx");
